
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/ways-to-protect-your-land-rights",
      function () {
        return require("private-next-pages/articles/ways-to-protect-your-land-rights.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/ways-to-protect-your-land-rights"])
      });
    }
  